import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { beatBlipSubscriptionConsts } from '../consts/beatBlipSubscriptionConsts';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class UserMgmtService {
    private url: string;
    private currentUser: any;
    private userType: String;
    private userCustomerProfile: any;
    workflowurl = environment.workflowUrl

    constructor(
        private http: HttpClient,
        private router: Router,
        private userService: UserService,
        @Inject(DOCUMENT) private document: Document) {
        this.url = environment.baseUrl;
      //  this.setCurrentUser();

    }
    // setCurrentUser() {
    //     this.userService.getUser().subscribe((data) => {
    //         this.currentUser = data;
    //         this.userService.getUserType(this.currentUser.userRoleId).subscribe((data) => {
    //             this.userType = data["roleName"];
    //             this.userCustomerProfile = data["CustomerProfile"];
    //         })

    //     });
    // }




    loadUserData(param?:any) {
        if(param){
            return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/companyAccountCustomers?comingfrom=automation');
        }
        else{
            return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/companyAccountCustomers');
        }
    }

    loadActiveUsers()
    {
        return this.http.get(this.workflowurl + '/user/all');
    }

    getCustomerData() {
        return this.currentUser;
    }

    getCustomerType() {
        return this.userType;
    }

    getCustomerProfile() {
        return this.getCustomerProfile;
    }

    editCustomer(userData: any) {
        return this.http.put(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/companyAccountCustomer', userData);

    }

    createCustomer(userData: any) {
        return this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/companyAccountCustomer', userData);

    }

    editCustomerProfile(userData: any) {
        return this.http.put(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/companyAccountCustomerProfile', userData);
    }

    getProjectInfo() {
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/projectList');
    }

    getUserRestrictionsForEntity(userId, projectId) {
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/get-user-restriction/' + userId + "/" + projectId);
    }


    createOrUpdateUserRestriction(userID, projectId, userRestrictions) {
        return this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/set-user-restriction/' + userID + "/" + projectId, userRestrictions);
    }

    updateAccessManagement(body)
    {
        return this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/set-user-restriction/v2', body);
    }

    getUserRestrictions(userId)
    {
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL +  '/access/get-user-restriction/' + userId);
    }

    updateDefaultView(check)
    {
        return this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + "/access/update-display-view/", check , {responseType: 'text'});
    }


}
